<template>
  <div id="user-details" class="wrrapper">
    <page-heading title="User Details" border back>
      <template #content>
        <div class="flex align-center flex-end">
          <Button
            className="button--primary"
            title="Update"
            :onClick="handleUpdate"
            :loader="loading"
          ></Button>
        </div>
      </template>
    </page-heading>
    <div class="details">
      <form class="row">
        <Input
          class="mb-base col-4"
          label="Full Name"
          type="text"
          v-model="user.full_name"
        />
        <DatePicker
          class="col-4"
          label="Age-Year"
          :input="ageYear"
          :value="user.dob"
          labelFor="dob"
        />
        <Input
          class="mb-base col-4"
          label="CNIC"
          type="number"
          v-model="user.cnic"
        />
        <Input
          class="mb-base col-4"
          label="Email Address"
          type="email"
          v-model="user.email"
        />
        <Input
          class="mb-base col-4"
          label="Phone Number"
          type="number"
          v-model="user.mobile_no"
        />
        <Radio
          class="mb-base col-4"
          outerLabel="Gender"
          type="radio"
          name="custom"
          v-model="genders"
          :options="gender"
        />
        <Input
          class="mb-base col-4"
          label="City"
          type="text"
          v-model="user.city"
        />
        <Input
          class="mb-base col-4"
          label="Address"
          type="text"
          v-model="user.address"
        />
        <DatePicker
          class="col-4"
          label="Joined Date"
          :input="joinedDate"
          :value="user.joinedDate"
          labelFor="dob"
        />
        <Select
          class="mb-base account-input col-4"
          label="User Role"
          placeholder="Select"
          styles="role-select"
          :input="handleRoles"
          :options="listDoctors"
          :loading="loading"
          :value="role"
          :clearable="false"
        />
        <Input
          class="mb-base col-4"
          label="Username"
          type="text"
          v-model="user.user_name"
        />
        <Input
          class="mb-base col-4"
          label="Password"
          type="password"
          v-model="user.password"
        />
        <Select
          class="mb-base account-input col-4"
          label="User Branch"
          styles="role-select"
          :input="handleBranchChange"
          :options="brachData"
          :loading="loading"
          :placeholder="
            brachData.find(item => item.key === userInfo.userBranchId).name
          "
          :clearable="false"
        />
        <Radio
          class="mb-base col-4"
          outerLabel="Is other"
          type="radio"
          v-model="isOther"
          :options="organizationType"
          styles="invoice-type"
        />
        <div class="relative" style="margin-top: -1.3rem;">
          <span>
            <p>
              2FA :
              <span v-if="is2faActive" class="active">Enable</span>
              <span v-if="!is2faActive" class="inactive">Disable</span>
            </p>
            <Button
              title="Remove 2fa"
              className="button--primary mt-1"
              :disabled="!is2faActive"
              style="width: 14rem;"
              :loader="disable2faLoading"
              :onClick="remove2fa"
            />
          </span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Input from "@/components/Input";
import Radio from "@/components/Radio";
import DatePicker from "@/components/Datepicker";
import Select from "@/components/Select";
import { api } from "@/axios";
import Button from "@/components/Button";
import { mapActions, mapGetters } from "vuex";
import { getGender, formatedDate, formatGender } from "@/utils/helpers";
export default {
  components: {
    Button,
    Select,
    DatePicker,
    Input,
    Radio
  },
  data() {
    return {
      user: {},
      role: "",
      genders: "",
      userBranch: "",
      disable2faLoading: false,
      is2faActive: false,
      isOther: "",
      brachData: [],
      organizationType: [
        { id: "familyhealth", for: "familyhealth", label: "FHH" },
        { id: "medirad", for: "medirad", label: "MEDI RAD" }
      ],
      gender: [
        { id: "male", for: "male", label: "Male" },
        { id: "female", for: "female", label: "Female" }
      ]
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters({ listDoctors: "doctors/listDoctors", loading: "loading" }),
    ...mapGetters("auth", ["userInfo"])
  },
  methods: {
    ...mapActions("user", ["userDetails", "handleUpdateUsers", "getEmployees"]),
    ...mapActions("doctors", ["doctorList"]),
    ageYear(val) {
      this.user.dob = formatedDate(val);
    },
    joinedDate(val) {
      this.user.joinedDate = formatedDate(val);
    },
    handleRoles(val) {
      this.role = val.name;
      this.user.role_name = this.role.toLowerCase();
    },
    handleBranchChange(val) {
      if (val && val != null) {
        this.user.branchId = val.key;
      }
    },
    async remove2fa() {
      try {
        this.disable2faLoading = true;
        const res = await api.delete("/2fa/disable2fa/" + this.getUser.userId);
        if (res.status == 200) {
          this.is2faActive = false;
          this.$toasted.success("2FA disabled successfully").goAway("3000");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.disable2faLoading = false;
      }
    },
    handleUpdate() {
      const user = {
        ...this.user,
        gender: getGender(this.genders),
        isOther: this.isOther == "FHH" ? 1 : 0
      };
      this.handleUpdateUsers({
        id: this.$route.params.id,
        user: user
      }).then(() => {
        this.$toasted.success("User updated succesfully").goAway("3000");
        this.getEmployees();
        this.$router.push("/users");
      });
    }
  },
  async mounted() {
    await this.userDetails(this.$route.params.id).then(() => {
      this.genders = formatGender(this.getUser.gender);
      this.is2faActive = this.getUser.is2fa;
      this.user = this.getUser;
    });
    this.user.branchId = this.userInfo.userBranchId;
    this.doctorList("roles");
    this.userInfo?.businessBranches?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
  },
  watch: {
    user(val) {
      this.role = val && val.role_name;
      this.userBranch =
        val && val.userBranch
          ? this.userInfo?.businessBranches.find(user => {
              return user.id === val.userBranch;
            })?.name
          : "";
      this.isOther = val.isOther == 1 ? "FHH" : "MEDI RAD";
    }
  }
};
</script>

<style>
#user-details {
  height: calc(100vh - 9rem);
}
#user-details .details {
  padding: 1rem 2.5rem;
}
</style>
<style scoped>
.active {
  color: var(--surface);
  background-color: var(--success);
  padding: 2px 8px;
  border-radius: 1rem;
  font-size: var(--fs-xs);
  font-weight: 500;
}
.inactive {
  color: var(--surface);
  background-color: var(--danger);
  padding: 2px 8px;
  border-radius: 1rem;
  font-size: var(--fs-xs);
  font-weight: 500;
}
</style>
